module.controller('sendGiftCtrl', ['$scope', '$stateParams', '$rootScope', '$http', '$state', '$filter', 'cacheService', 'Transform', 'Session', 'memberService', 'LimitsService', 'baseURI', 'OVERLAY',
  function ($scope, $stateParams, $rootScope, $http, $state, $filter, cacheService, Transform, Session, memberService, LimitsService, baseURI, OVERLAY){
    var transferUrl = baseURI + 'giftcard/send';

    $scope.overlay = OVERLAY['member.home.send/gift'];
    $scope.formData = {};

    $scope.attempted = false;

    $scope.alert = {};
    $scope.alert.alertMessage = 'Sorry, we were unable to process the transfer at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';
    $scope.limits = Session.getLimits()['CRD-TRN-OUT'];
    $scope.amountValid = false;
    $scope.amountMessage = null;
    $scope.balance = $rootScope.balance;

    // Adds context to the amount messaging
    $scope.formatAmountMessage = function(){
      var amount = $scope.formData.Amount;
      var balance = $scope.balance;
      var volumeLimit = ($scope.limits && $scope.limits.volume) || null;

      if(amount){
        if (amount > balance){
          $scope.amountValid = false;
          $scope.amountMessage = 'Oops, there\'s not enough on your ' + $scope.brand.commonProgramName + '.';
        }
        else if (volumeLimit && amount > volumeLimit){
          $scope.amountValid = false;
          $scope.amountMessage = 'Oops, looks like the current limit today is ' + $filter('akimboCurrency')(volumeLimit, '$') + '.';
        }
        else {
          $scope.amountValid = true;
          $scope.amountMessage = 'ok';
        }
      } else {
        $scope.amountValid = false;
        $scope.amountMessage = null;
      }
    };

    $scope.$watch('formData.Source', $scope.formatAmountMessage);

    // Validation for step2
    $scope.attemptSubmission = function (formData){
      if(formData.$valid && $scope.amountValid){
        $scope.lowFunds = false;
        $scope.alert.errorShown = false;
        $state.go('member.home.send/gift.step2');
      } else {
        $scope.alert.errorShown = true;
        $scope.attempted = true;
      }
    };

    // Review and submit
    $scope.processForm = function(formData){
      $scope.loading = true;

      $http({
        method: 'POST',
        url: transferUrl,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: Transform.encode($scope.formData)
      }).then(function(resp){
        var data = resp.data;

        $scope.loading = false;
        if(data.Success){
          // Clear the balance and feed cache
          cacheService.clear('transfer');

          // Update the feature limits
          LimitsService.update();

          $state.go('member.home.send/gift.step3');
          $scope.alert.successShown = true;
          $scope.alert.successMessage = 'You\'ve sent a ' + $filter('akimboCurrency')(formData.Amount, '$') + ' gift to ' + $scope.formData.FirstName + ' ' + $scope.formData.LastName;
        } else {
          $scope.alert.alertShown = true;
        }
      }).catch(function (error){
        $scope.loading = false;
        $scope.alert.alertShown = true;
      });
    };

  }]);

